<template>
    <popup-modal ref="popup" id="confirmModal" :class="theme">
        <h3 v-if="title && title.length" class="window-title not-selectable">{{ title }}</h3>
        <slot name="content">
            <p class="content not-selectable">{{ message }}</p>
        </slot>
        <div class="btns" :class="{'direction-column': columnDirectionButtons}">
          <button v-if="confirmButtonText" class="confirm-button not-selectable" @click="confirmClick">{{ confirmButtonText }}</button>
          <button v-if="cancelButtonText"
            class="cancel-button not-selectable"
            :class="{'link': cancelButtonAsLinkText == true}"
            @click="cancelClick">{{ cancelButtonText }}</button>  
        </div>
    </popup-modal>
</template>

<script>
import PopupModal from './PopupModal.vue'

export default {
    name: 'ConfirmDialogue',
    props: {
        theme: {
            type: String,
            default: 'dark'
        },
    },
    components: { PopupModal },

    data: () => ({
        // Parameters that change depending on the type of dialogue
        title: undefined,
        message: undefined,
        confirmButtonText: undefined,
        cancelButtonText: 'Отмена',
        cancelButtonAsLinkText: false,
        isOpen: false,
        // Private variables
        resolvePromise: undefined,
        rejectPromise: undefined,
        columnDirectionButtons: false,
    }),

    methods: {
        show(opts = {}) {
            this.title = opts.title;
            this.message = opts.message;
            this.columnDirectionButtons = opts.columnDirectionButtons && opts.columnDirectionButtons === true;
            this.confirmButtonText = opts.confirmButtonText;
            this.cancelButtonText = opts.cancelButtonText;
            this.cancelButtonAsLinkText = opts.cancelButtonAsLinkText === true;
            location.hash = '#modal';
            setTimeout(() => window.onhashchange = this.onHashChange, 100);
            // Once we set our config, we tell the popup modal to open
            this.isOpen = true;
            this.subscribeEvents();
            this.$refs.popup.open();
            // Return promise so the caller can get results
            return new Promise((resolve, reject) => {
                this.resolvePromise = resolve
                this.rejectPromise = reject
            })
        },

        onHashChange() {
            if (!this.isOpen) return;
            window.history.pushState('forward', null, '');
            document.getElementById("cancelButton").click();
        },

        confirmClick() {
            this.closeModal();
            this.resolvePromise(true)
        },

        cancelClick() {
            this.closeModal();
            this.resolvePromise(false)
            // Or you can throw an error
            // this.rejectPromise(new Error('User canceled the dialogue'))
        },

        closeModal() {
            if (location.hash === '#modal') {
                // window.history.back();
                this.$router.push({ path: window.location.pathname + window.location.search, replace: true });
            }
            window.onhashchange = {};
            this.isOpen = false;
            this.unsubscribeEvents();
            this.$refs.popup.close();
            this.$emit('close');
        },

        handleClick(e) {
            if (this.isOpen && $(e.target).is('#confirmModal')) {
                this.cancelClick();
            }
        },

        handleKeyDown(event) {
            if (this.isOpen && event.keyCode == 27) { 
                this.cancelClick();
            }
        },

        subscribeEvents() {
            document.addEventListener('click', this.handleClick, true);
            document.addEventListener('keydown', this.handleKeyDown, true);
        },

        unsubscribeEvents() {
            document.removeEventListener('click', this.handleClick, false);
            document.removeEventListener('keydown', this.handleKeyDown, false);
        }
    },
    beforeDestroy() {
        this.unsubscribeEvents();
    }
}
</script>

<style lang="css" scoped src='../assets/css/ConfirmationDialogue.css'>
</style>